// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2fZfN","label":"CategoryService_label__3j7fy","location":"CategoryService_location__1nuHl"};